import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e07dfeca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tipBox" }
const _hoisted_2 = { class: "titleBox" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请尽快完成实名认证", -1))
const _hoisted_4 = { class: "tipContent" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("根据国家相关法律规定，网络直播需通过实名认证，请前往"),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"#00ccb0","cursor":"pointer"},
    href: "/personal/set/certification",
    target: "blank"
  }, "实名认证"),
  /*#__PURE__*/_createTextVNode("或微信扫描认证，请严格遵守国家相关法律规定开展直播活动")
], -1))
const _hoisted_6 = { class: "imgBox" }
const _hoisted_7 = { class: "img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信扫码认证", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 如有疑问可咨询："),
  /*#__PURE__*/_createElementVNode("a", { href: "tel:400-920-1599" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#00ccb0","cursor":"pointer"} }, "400-920-1599")
  ])
], -1))

import { withDefaults } from 'vue';
import { Modal } from 'ant-design-vue';
import { getToken } from '@/plugins/cookie';
import { useQRCode } from '@vueuse/integrations/useQRCode';

// `qrcode` will be a ref of data URL
export interface RootModal {
  visible: boolean;
  loading: boolean;
}
interface Props {
  visible: boolean;
  loading?: boolean;
  centered?: boolean;
  closable?: boolean;
  footer?: null;
  close: (...args: any[]) => any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CModal',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    footer: null,
    close: null
  },
  setup(__props: any) {

const props = __props as { visible: boolean, loading: boolean, centered: boolean, closable: boolean, footer?: null, close: (...args: any[]) => any };

const aModal = Modal;
const token = getToken();

const qr_url = window.location.origin + '/verification?lighostoken=' + token;

const qrcode = useQRCode(qr_url, {
  margin: 0,
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_unref(aModal), {
    visible: props.visible,
    centered: props.centered,
    closable: props.closable,
    footer: null,
    onCancel: props.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_svg_icon, {
            "icon-class": "warning",
            class: "delete_icon"
          }),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("img", {
                src: _unref(qrcode),
                alt: "QR Code"
              }, null, 8, _hoisted_8)
            ]),
            _hoisted_9
          ]),
          _hoisted_10
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "centered", "closable", "onCancel"]))
}
}

})